import { ScanTemplatePart, ScanTemplatePartType } from './ScanTemplateSchemas';

export const SCAN_TEMPLATE_CHILDREN_FIELD_NAMES_BY_DEPTH = ['groupTemplates', 'taskTemplates', 'optionTemplates', 'lineItemTemplates'] as const;
export const SCAN_TEMPLATE_PART_DEPTHS_BY_NAME: Record<ScanTemplatePartType, number> = {
  scanTemplate: 0,
  groupTemplate: 1,
  taskTemplate: 2,
  optionTemplate: 3,
  lineItemTemplate: 4,
} as const;
export const SCAN_TEMPLATE_PART_TYPES_BY_DEPTH: ScanTemplatePartType[] = [
  'scanTemplate',
  'groupTemplate',
  'taskTemplate',
  'optionTemplate',
  'lineItemTemplate',
] as const;
export const MAX_SCAN_TEMPLATE_DATA_STRUCTURE_RECURSION_DEPTH = 4; // 0, 1, 2 and 3 are valid, 4+ is not
export const validateScanTemplateDataStructureRecursionDepth = (recursionDepth: number) => {
  if (recursionDepth > MAX_SCAN_TEMPLATE_DATA_STRUCTURE_RECURSION_DEPTH) {
    throw new Error(
      `Exceeded Scan Template Data Structure Recursion Limit: Recursion depth ${recursionDepth} is greater than the maximum allowed depth ${MAX_SCAN_TEMPLATE_DATA_STRUCTURE_RECURSION_DEPTH}`,
    );
  }
};

export const getScanTemplateChildrenFieldName = (recursionDepth: number): string => {
  validateScanTemplateDataStructureRecursionDepth(recursionDepth);
  return SCAN_TEMPLATE_CHILDREN_FIELD_NAMES_BY_DEPTH[recursionDepth];
};

export const getScanTemplateChildren = (scanTemplatePart: ScanTemplatePart, recursionDepth: number): ScanTemplatePart[] => {
  validateScanTemplateDataStructureRecursionDepth(recursionDepth);
  const childrenFieldName = SCAN_TEMPLATE_CHILDREN_FIELD_NAMES_BY_DEPTH[recursionDepth];
  return (scanTemplatePart as any)[childrenFieldName] as ScanTemplatePart[];
};

export const setScanTemplateChildren = (mutatingScanTemplatePart: ScanTemplatePart, children: ScanTemplatePart[], recursionDepth: number): ScanTemplatePart => {
  validateScanTemplateDataStructureRecursionDepth(recursionDepth);
  (mutatingScanTemplatePart as any)[getScanTemplateChildrenFieldName(recursionDepth)] = children;
  return mutatingScanTemplatePart;
};
